import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import $ from 'jquery'
import arrowDown from '../../imgs/misc/ArrowDown.svg'
import LoginModal from './Modals/LoginModal'
import { setHeaderLocation } from '../../js/helpers/apiHelper'

const Header = () => {
  const {
    dictionary,
    aegeanLogo,
    hertzLogo,
    hertzLogoMobile,
    languages,
    locations,
    menuItems,
    loginModal,
    configuration,
    userId,
    homeLink,
  } = window.headerData
  const [menuOpen, setMenuOpen] = useState(false) // Controls mobile side menu visibility
  const [openDropdown, setOpenDropdown] = useState(null)
  const [isSticky, setIsSticky] = useState(false)
  const [headerHeight, setHeaderHeight] = useState(0)
  const [openLoginModal, setOpenLoginModal] = useState(false)
  const [location, setLocation] = useState(
    localStorage.getItem('location') ||
      locations?.find((item) => item.selected)?.value ||
      locations?.[0]?.value,
  )

  const headerRef = useRef(null)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)
    window.addEventListener('openLoginModal', handleOpenLoginModal)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
      window.removeEventListener('openLoginModal', handleOpenLoginModal)
    }
  }, [])

  useEffect(() => {
    if (headerRef.current) {
      const headerHeight = $(headerRef.current).outerHeight(true)
      setHeaderHeight(headerHeight)
    }
  }, [headerRef.current])

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index) // Toggle individual dropdown menus
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen) // Toggle the side menu open/close
  }

  const handleScroll = () => {
    const importantNoticesHeight =
      document.getElementById('important-notices')?.offsetHeight ?? 0

    if (window.scrollY > importantNoticesHeight) {
      setIsSticky(true)
    } else {
      setIsSticky(false)
    }
  }

  const handleResize = () => {
    setMenuOpen(false)
    setOpenDropdown(null)
  }

  const preventDefault = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleOpenLoginModal = () => {
    setOpenLoginModal(true)
  }

  const handleChangeLocation = (e) => {
    setLocation(e.target.value)
    localStorage.setItem('location', e.target.value)
    setHeaderLocation(e.target.value)
    if (window.location.pathname !== '/') {
      setTimeout(() => {
        window.location.href = '/'
      })
    }
  }

  useEffect(() => {
    if (!localStorage.getItem('location')) {
      localStorage.setItem(
        'location',
        locations?.find((item) => item.selected)?.value ||
          locations?.[0]?.value,
      )
    }
  }, [])

  useEffect(() => {
    if (menuOpen) {
      document.documentElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
    } else {
      document.documentElement.removeAttribute('style')
      document.body.removeAttribute('style')
    }
  }, [menuOpen])

  return (
    <div>
      <div
        className={`s-header__placeholder ${
          isSticky ? 's-header__placeholder--visible' : ''
        }`}
        style={{ height: `${headerHeight}px` }}></div>
      <header
        ref={headerRef}
        className={`s-header ${isSticky ? 's-header--sticky' : ''}`}>
        {/* Logos */}
        <div className="page-container">
          <div className="s-header__body">
            <div className="s-header__left">
              <a href={homeLink?.url} title={homeLink?.text}>
                <img
                  src={aegeanLogo?.url}
                  alt={aegeanLogo?.alt}
                  className="s-header__logo s-header__logo--main"
                />
                <div className="s-header__divider" />
                <img
                  src={hertzLogo?.url}
                  alt={hertzLogo?.alt}
                  className="s-header__logo s-header__logo--secondary"
                />
              </a>
            </div>

            {/* Burger menu icon for mobile */}
            <button
              type="button"
              className="s-header__burger-icon"
              onClick={toggleMenu}
              aria-label={
                menuOpen ? 'Close navigation menu' : 'Open navigation menu'
              }
              aria-expanded={menuOpen}>
              {menuOpen ? '✕' : '☰'}
            </button>

            {/* Right side */}
            <div className="s-header__right">
              <div className="s-header__right__top">
                <div className="language">
                  <label htmlFor="language-selector" className="prefix">
                    <i className="icon-globe" title="Select Language"></i>
                  </label>

                  <select id="language-selector" className="language-selector">
                    {languages.map((language) => (
                      <option key={language.value}>{language.label}</option>
                    ))}
                  </select>
                </div>
                <div className="location">
                  <i className="icon-profile"></i>
                  <label htmlFor="location-selector" className="prefix">
                    {dictionary.locationLabel}
                  </label>
                  <select
                    id="location-selector"
                    className="location-selector"
                    value={location}
                    onChange={handleChangeLocation}>
                    {locations.map((location) => (
                      <option key={location.value} value={location.value}>
                        {location.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="s-header__right__bottom">
                {menuItems.map((item, index) =>
                  item.type === 'dropdown' ? (
                    <div
                      key={index}
                      className="s-header__menu-item"
                      onMouseEnter={() => setOpenDropdown(index)}
                      onMouseLeave={() => setOpenDropdown(null)}>
                      {item.label} <i className="icon-arrow-down arrow"></i>
                      {openDropdown === index && (
                        <div className="s-header__dropdown">
                          <ul className="links">
                            {item.options
                              .filter((option) => option.type !== 'featured')
                              .map((option, i) => (
                                <li key={i}>
                                  <a
                                    href={option.href}
                                    className="s-header__dropdown-link">
                                    {option.label}
                                    {option.tag && (
                                      <div
                                        className="s-header__dropdown-tag"
                                        style={{
                                          backgroundColor: option.tagColor,
                                        }}>
                                        {option.tag}
                                      </div>
                                    )}
                                  </a>
                                </li>
                              ))}
                          </ul>
                          {item.options
                            .filter((option) => option.type === 'featured')
                            .map((option, i) => (
                              <div key={i} className="featured">
                                <a href={option.url.href}>
                                  <img src={option.image} alt={option.label} />
                                  <span>{option.label}</span>
                                  <span className="view-more">
                                    {option.url.label} →
                                  </span>
                                </a>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  ) : item.type === 'auth' ? (
                    <button
                      type="button"
                      role="button"
                      key={index}
                      className="btn p-0 s-header__link"
                      title={item.label}
                      onClick={() => setOpenLoginModal(true)}>
                      {item.label}
                    </button>
                  ) : item.type === 'button' ? (
                    <button
                      type="button"
                      role="button"
                      key={index}
                      className={`btn p-0 s-header__link`}
                      data-target={item.targetButtonId}
                      title={item.label}>
                      {item.label}
                    </button>
                  ) : (
                    <a href={item.href} key={index} className="s-header__link">
                      {item.label}
                    </a>
                  ),
                )}
              </div>
            </div>

            {/* Mobile menu */}
            {menuOpen && (
              <div className="s-header__side-menu">
                <div className="s-header__side-menu__content">
                  {menuItems.map((item, index) =>
                    item.type === 'dropdown' ? (
                      <div
                        key={index}
                        className="s-header__menu-item"
                        onClick={() => toggleDropdown(index)}>
                        {item.label}{' '}
                        <img className="forward-arrow" src={arrowDown}></img>
                        {openDropdown === index && (
                          <div className="s-header__dropdown">
                            <div
                              className="s-header__mobile-back"
                              onClick={() => toggleDropdown(index)}>
                              <img className="back-arrow" src={arrowDown}></img>{' '}
                              {openDropdown === index ? item.label : ''}
                            </div>
                            <ul className="links">
                              {item.options
                                .filter((option) => option.type !== 'featured')
                                .map((option, i) => (
                                  <li key={i}>
                                    <a
                                      href={option.href}
                                      className="s-header__dropdown-link">
                                      <div>
                                        {option.label}
                                        {option.tag && (
                                          <div
                                            className="s-header__dropdown-tag"
                                            style={{
                                              backgroundColor: option.tagColor,
                                            }}>
                                            {option.tag}
                                          </div>
                                        )}
                                      </div>
                                      <img
                                        className="forward-arrow"
                                        src={arrowDown}></img>
                                    </a>
                                  </li>
                                ))}
                            </ul>
                            {item.options
                              .filter((option) => option.type === 'featured')
                              .map((option, i) => (
                                <div key={i} className="featured">
                                  <a href={option.url.href}>
                                    <img
                                      src={option.image}
                                      alt={option.label}
                                    />
                                    <span>{option.label}</span>
                                    <span className="view-more">
                                      {option.url.label} →
                                    </span>
                                  </a>
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <a
                        href={item.href}
                        key={index}
                        className="s-header__link">
                        {item.label}{' '}
                        <img className="forward-arrow" src={arrowDown}></img>
                      </a>
                    ),
                  )}
                </div>
                <div className="s-header__side-menu__footer">
                  <div className="language">
                    <i className="icon-globe"></i>
                    <select className="language-selector">
                      {languages.map((language) => (
                        <option key={language.value}>{language.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="location">
                    <i className="icon-profile"></i>
                    <span className="prefix">{dictionary.locationLabel}</span>
                    <div className="location-selector-container">
                      <select
                        className="location-selector"
                        value={location}
                        onChange={handleChangeLocation}>
                        {locations.map((location) => (
                          <option key={location.value} value={location.value}>
                            {location.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div>
                    <img
                      src={hertzLogoMobile?.url}
                      alt={hertzLogoMobile?.alt}
                      className="s-header__logo"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <LoginModal
        open={openLoginModal}
        handleClose={() => setOpenLoginModal(false)}
      />
    </div>
  )
}

export default Header
